import styles from "./AdminPanel.module.css";
import { Autocomplete, TextField, FormControlLabel, Checkbox, Button } from "@mui/material";
import Icon from "@mdi/react";
import { mdiWeight, mdiAccount } from "@mdi/js";
import { mdiPencil, mdiDelete, mdiChatOutline } from "@mdi/js";
import ConfirmDialog from "components/ConfirmDialog";
import { useSnackbar } from "notistack";

// react
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// components
import DropDownMenu from "components/DropDownMenu";
import { dropDownPublicationOptionsArray } from "tools/getPublication";
import { dropDownStatusOptionsArray } from "tools/getStatus";
import { dropDownPriorityOptionsArray } from "tools/getPriority";
import { dropDownModuleOptionsArray } from "tools/getModule";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// tools
import Services from "tools/Services";
import Loader from "components/Loader";

export default function AdminPanel(props) {
	const { role } = useContext(MyContext);
	const [voters, setVoters] = useState([]);
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [openDialog, setOpendialog] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	useEffect(() => {
		loadVoters();
		loadUsers();
	}, []);

	const loadVoters = async () => {
		// GET
		let res = await Services.get("/Feature/vote/" + props.feature.idFeature);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setVoters(res.data);
		setLoading(false);
	};

	const loadUsers = async () => {
		// GET
		let res = await Services.get("/User/getUsers/");

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		// We only can choose Users not admins to add requested by
		setUsers(res.data.filter((user) => user.roles == "User"));
	};
	const deleteWithDialog = (reason) => {
		if (reason == "yes") {
			handleDeleteFeature(props.feature.idFeature);
			history.goBack();
		}
		setOpendialog(false);
	};
	const handleChange = (e) => {
		props.updateFeature({ ...props.feature, [e.target.name]: e.target.value });
	};
	const handleChangeCheckbox = (e) => {
		props.updateFeature({ ...props.feature, [e.target.name]: e.target.checked });
	};
	const handleChangeRequestedBy = (e, values) => {
		props.updateFeature({ ...props.feature, requestedBy: values });
	};
	const handleDeleteFeature = async (id) => {
		// DELETE
		let res = await Services.delete("/Feature/" + id);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			enqueueSnackbar(res, {
				variant: "error",
			});
			return;
		}

		// SUCCESS
		enqueueSnackbar("Deleted", {
			variant: "success",
		});
	};

	return (
		<>
			{role === Role.Admin && (
				<div className={styles.container}>
					<div className={styles.admin}>
						<div className={styles.title}>Admin</div>
						<hr className={styles.hr}></hr>
						<DropDownMenu
							items={[...dropDownModuleOptionsArray]}
							selectedItem={dropDownModuleOptionsArray[props.feature.module]}
							width={{ width: 160 }}
							onSelect={props.onChange}
							selectedItemWithLabel={true}
							type="module"
						/>
						<DropDownMenu
							items={dropDownStatusOptionsArray}
							selectedItem={dropDownStatusOptionsArray[props.feature.status]}
							width={{ width: 160 }}
							onSelect={props.onChange}
							type="status"
						/>
						<DropDownMenu
							items={dropDownPriorityOptionsArray}
							selectedItem={dropDownPriorityOptionsArray[props.feature.priority]}
							width={{ width: 135 }}
							onSelect={props.onChange}
							type="priority"
						/>
						<DropDownMenu
							items={dropDownPublicationOptionsArray}
							selectedItem={dropDownPublicationOptionsArray[+props.feature.published]}
							width={{ width: 80 }}
							onSelect={props.onChange}
							type="published"
						/>
						<label className={styles.label}>Est. dev. time (in days)</label>
						<TextField
							sx={{ width: 30 }}
							variant="standard"
							name="estDevTimeInDays"
							placeholder="Nb"
							type="text"
							value={props.feature.estDevTimeInDays}
							onChange={handleChange}
						/>
						<label className={styles.label}>Feedback ID</label>
						<TextField
							sx={{ width: 60 }}
							variant="standard"
							name="idFeedback"
							placeholder="Nb"
							type="text"
							value={props.feature.idFeedback}
							onChange={handleChange}
						/>
						<FormControlLabel
							label="Custom"
							control={
								<Checkbox
									checked={props.feature.custom}
									name="custom"
									onChange={handleChangeCheckbox}
								/>
							}
						/>
						<FormControlLabel
							label="Beta"
							control={
								<Checkbox checked={props.feature.beta} name="beta" onChange={handleChangeCheckbox} />
							}
						/>
						<Autocomplete
							sx={{ minWidth: 200, zIndex: 0 }}
							multiple
							id="tags-outlined"
							options={users}
							getOptionLabel={(option) => option.userName}
							value={props.feature.requestedBy}
							filterSelectedOptions
							isOptionEqualToValue={(option, value) => option.id === value.id}
							onChange={handleChangeRequestedBy}
							renderInput={(params) => <TextField {...params} label="Requested By" placeholder="" />}
						/>
						<ConfirmDialog open={openDialog} title={"Attention"} yes no onClose={deleteWithDialog}>
							{"Are you sure you want to delete this feature?"}
						</ConfirmDialog>
						<Button variant="outlined" onClick={() => setOpendialog(true)}>
							Delete Feature
							<Icon path={mdiDelete} size={1} color="grey" className={styles.delete} />
						</Button>
					</div>

					<div className={styles.admin}>
						<div className={styles.title}>Voters</div>
						<hr className={styles.hr}></hr>
						{loading ? (
							<Loader />
						) : (
							<>
								{voters.map((user) => {
									return (
										<div key={user.id} className={styles.voters}>
											<Icon path={mdiAccount} size={1} color="grey" />
											{user.userName}
											<Icon path={mdiWeight} size={1} color="grey" />
											{user.weight}
										</div>
									);
								})}
								{voters.length === 0 && <div style={{ color: "grey" }}>No voters yet</div>}
							</>
						)}
					</div>
				</div>
			)}
		</>
	);
}
